import { useEffect, useState } from "react";
import apiAgent from "../api/apiAgent";
import { Button } from "../components/Button";
import { SectionCard } from "../components/HomeLayouts";
import { PageContainer, PageContent } from "../components/PageContainer";
import { changesSchema } from "../components/Publishing/atoms";
import { tMsg } from "../components/ToastNotifications";
import {
  IUploadLocations,
  MediaInput,
} from "../components/Forms/FileHandling/MediaInput";
import { ImageWithLoading } from "../components/ImageWithLoading";
import {
  getImageThumbnailFromURL,
  getStillVideoFrameFromURL,
} from "../components/Forms/FileHandling/Utils";
import { toPng } from "html-to-image";

const TestPage = () => {
  const [testUploadImageData, setTestUploadImageData] =
    useState<IUploadLocations>();
  const [testUploadVideoData, setTestUploadVideoData] =
    useState<IUploadLocations>();

  const checkValidation = async () => {
    const response = await apiAgent.Auth.validate();
    console.log(response);
    if (response.status === 200) {
      tMsg.success("Your login is valid");
    } else {
      tMsg.warning("Invalid login");
    }
  };

  const resetPublishData = async () => {
    const now = new Date().toLocaleString();
    const schema = changesSchema;
    const data = { lastchange: now, lastpublish: now };
    const allCalls = [
      apiAgent.SingleItem.update("changes-schoolphotos", data, schema),
      apiAgent.SingleItem.update("changes-slides", data, schema),
    ];

    try {
      const responses = await Promise.all(allCalls);
      const errors = responses.reduce((count, response) => {
        if (response.status !== 200) {
          tMsg.warning(response.statusText);
          return count + 1;
        }
        return count;
      }, 0);
      if (errors > 0) tMsg.warning(`${errors} items not reset`);
      else tMsg.success(`All publish dates reset`);
    } catch {
      tMsg.warning("Error adding publish data");
    }
  };

  const addPublishData = async () => {
    const now = new Date().toLocaleString();
    const schema = changesSchema;
    const data = { lastchange: now, lastpublish: now };
    const allCalls = [
      apiAgent.SingleItem.create("changes-schoolphotos", data, schema),
      apiAgent.SingleItem.create("changes-slides", data, schema),
    ];

    try {
      const responses = await Promise.all(allCalls);
      const errors = responses.reduce((count, response) => {
        if (response.status !== 200) {
          tMsg.warning(response.statusText);
          return count + 1;
        }
        return count;
      }, 0);
      if (errors > 0) tMsg.warning(`${errors} items not reset`);
      else tMsg.success(`All publish dates reset`);
    } catch {
      tMsg.warning("Error adding publish data");
    }
  };

  const checkPublishData = async (group: string) => {
    const response = await apiAgent.SingleItem.get(`changes-${group}`);
    console.log(response.data);
    if (response.status === 200) tMsg.success(`Retrieved data from ${group}`);
  };

  const [thumbUrl, setThumbUrl] = useState<string | null>(null);
  const url = `https://lightwell-nextsense-site-syd.s3.ap-southeast-2.amazonaws.com/220923_NextSense_01_030.jpg?${Math.random()}`;
  // "https://lightwell-nextsense-site-syd.s3.ap-southeast-2.amazonaws.com/Revolutionaries_7_Evatt.mp4";
  const testThumb = () => {
    const element = document.getElementById("generate-thumb");
    if (element) {
      toPng(element).then((dataUrl: string) => {
        setThumbUrl(dataUrl);
        console.log("generated overlay data", dataUrl);
      });
    }
  };

  useEffect(() => {
    console.log(thumbUrl);
  }, [thumbUrl]);

  return (
    <PageContainer>
      <PageContent className="space-y-8">
        <SectionCard>
          <div className="font-bold">Test Stuff</div>
          <div className="text-sm">
            This section will be removed before client access given
          </div>
          <div className="flex gap-2 text-xs">
            Toast tester:
            <Button
              onClick={() =>
                tMsg.success(
                  "Hello! What a really long toast this is. I wonder how long toasts can go!"
                )
              }
            >
              Success Toast
            </Button>
            <Button onClick={() => tMsg.info("Info toast")}>Info Toast</Button>
            <Button onClick={() => tMsg.warning("Warning toast")}>
              Warning Toast
            </Button>
            <Button onClick={() => tMsg.error("Error toast")}>
              Error Toast
            </Button>
          </div>
          <div className="flex gap-2 text-xs">
            Test items:
            <Button onClick={() => checkValidation()}>Validate login</Button>
            <Button onClick={() => resetPublishData()}>
              Reset Publish Data
            </Button>
          </div>
          <div className="flex gap-2 text-xs">
            Temp publish:
            <Button onClick={() => checkPublishData("schoolphotos")}>
              Check student work & photos
            </Button>
            <Button onClick={() => checkPublishData("slides")}>
              Check slides
            </Button>
          </div>
        </SectionCard>
        <div className="space-y-4">
          <div className="font-bold">Test Thumb Generation</div>
          <div className="w-[320px] h-[320px]" id="generate-thumb">
            <img
              src={url}
              className="object-cover w-full h-full"
              crossOrigin="anonymous"
            />
          </div>
          <Button onClick={() => testThumb()}>Test Thumb</Button>
          {thumbUrl !== null && <img src={thumbUrl} />}
        </div>
      </PageContent>
    </PageContainer>
  );
};

export default TestPage;
